/**
 * ObservabilityController - Centralized observability tracking controller. 
 * This controller provides a unified interface for tracking observability events across the application.
 */

import * as AuthObservability from './services/auth-observability';

export interface TrackAuthSigninAttemptParams {
  authMethod: AuthObservability.AuthMethod;
  tenantId: string;
}

export interface TrackAuthSigninSuccessParams {
  userId: string;
  sessionId: string;
  authMethod: AuthObservability.AuthMethod;
  tenantId: string;
}

export interface TrackAuthSigninFailureParams {
  error: unknown;
  errorCategory: AuthObservability.AuthErrorCategory;
  sessionId: string;
  authMethod: AuthObservability.AuthMethod;
  tenantId: string;
}

export const ObservabilityController = {
  trackAuthSigninAttempt(params: TrackAuthSigninAttemptParams): string {
    return AuthObservability.AuthObservabilityService.trackSigninAttempt({
      authMethod: params.authMethod,
      tenantId: params.tenantId,
    });
  },

  trackAuthSigninSuccess(params: TrackAuthSigninSuccessParams): void {
    AuthObservability.AuthObservabilityService.trackSigninSuccess({
      userId: params.userId,
      sessionId: params.sessionId,
      authMethod: params.authMethod,
      tenantId: params.tenantId,
    });
  },

  trackAuthSigninFailure(params: TrackAuthSigninFailureParams): void {
    AuthObservability.AuthObservabilityService.trackSigninFailure({
      error: params.error,
      errorCategory: params.errorCategory,
      sessionId: params.sessionId,
      authMethod: params.authMethod,
      tenantId: params.tenantId,
    });
  },
} as const;

